import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Button } from '~/components/Button/Button';
import { PropsWithChildren } from 'react';
import styles from './Table.module.css';

type Props = PropsWithChildren;

export function Filter({ children }: Props) {
  return (
    <Popover className="relative">
      <PopoverButton as={Button} type="button" variant="secondary">
        Filtrering
      </PopoverButton>

      <PopoverPanel anchor="bottom end" className={styles.filterPanel}>
        {children}
      </PopoverPanel>
    </Popover>
  );
}
